import React from 'react';
import TemplatePage from '../../../components/templatePage';
import { useDispatch, useSelector } from 'react-redux';
import { setWithdrawals } from '../../store/thunk/setWithdrawals';
import PaymentItem from '../../components/paymentItem';
import {isArray} from 'lodash';
import { setLoadingAction } from '../../../components/templatePage/store/action';
import { setWithdrawalsAction } from '../../store/action';
import moment from 'moment';

const handleLoadPagination = ({page, setPage, countPage, dispatch, date_to, date_from}) => {
    if (page <= countPage) {
        setPage(page + 1);
    }
}

const handleLoading = (dispatch) => {
    dispatch(setLoadingAction(true))
}

const Withdrawals = () => {
    const utc = moment.utc().valueOf();
    const dispatch = useDispatch();
    const [page, setPage] = React.useState(0);
    const [current_date, setCurrentDate] = React.useState(utc);
    const [startDate, setStartDate] = React.useState(0);
    const [search, setSearch] = React.useState('')

    React.useEffect(() => {
        dispatch(setWithdrawals({
            page: 1,
            rowsPerPage: (page + 1) * 50,
            search,
            date_from: startDate,
            date_to: current_date
        }))
    }, [search, startDate, current_date, page])
    
    const list = useSelector(state => state.withdrawalsMobile.withdrawals);

    return (
        <TemplatePage
            title="Отчет по платежам"
            pagination={page < list.countPage && list.data.length}
            handleLoadPagination={() => handleLoadPagination({
                page,
                setPage,
                countPage: list.countPage
            })}
            handleLoading={() => handleLoading(dispatch)}
            datePicker
            changeDate={({date_from, date_to}) => {
                dispatch(setWithdrawalsAction({
                    data: [],
                    countPage: 1
                }));
                setCurrentDate(date_to);
                setStartDate(date_from)
                setPage(0)
            }}
            search={true}
            searchValue={search}
            onChangeSearch={(v) => {
                dispatch(setWithdrawalsAction({
                    data: [],
                    countPage: 1
                })); 
                setSearch(v);
                setPage(0)
            }}
        >
            {
               list.data.map((item) => <PaymentItem item={item} array={isArray(item)}/>)
            }   
            {
                !list.data.length && <span style={{width: '100%', color: '#fff', display: 'flex', justifyContent: 'center', padding: 20}}>Информация отсутствует</span>
            }
        </TemplatePage>
    )
}

export default Withdrawals;